module.exports = __webpack_public_path__ + "img/camera.074976c7.png";